// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__IVR7B","content":"styles_content__2pLGs"};